import authSignFetchReqest from 'js/Services/Auth/authSignFetchReqest.js';

const getAccountSubscriptionsByPlanHandle = async (accountId, planHandle, includePlanData = true, authService) => {
    if (!accountId) {
        throw new Error('Account ID is required');
    }

    if (!planHandle) {
        throw new Error('Plan handle is required');
    }

    if (!authService) {
        throw new Error('Auth service is required');
    }

    let url = `/rest-api/accounts/${encodeURIComponent(accountId)}/subscriptions/by-plan-handle/${encodeURIComponent(planHandle)}`;
    if (includePlanData) {
        url += '?includePlanData=true';
    }

    const [signedUrl, requestOptions] = authSignFetchReqest(
        url,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        },
        authService
    );

    let response = null;
    try {
        response = await fetch(signedUrl, {
            ...requestOptions,
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        });
    } catch (error) {
        console.error('Network error fetching account subscriptions by plan handle:', error);
        throw error;
    }

    if (response.status === 401) {
        throw new Error('Unauthorized');
    }

    if (response.status === 400) {
        throw new Error('AccountIdInvalid');
    }

    if (response.status === 404) {
        throw new Error('PlanHandleInvalid');
    }

    if (response.status !== 200 && response.status !== 304) {
        throw new Error('InternalServerError');
    }

    const data = await response.json();
    return data;
};

export default getAccountSubscriptionsByPlanHandle;